module.exports = __webpack_public_path__ + "img/bj14.27d601d5.png";